import {
  CreateCollectionPayload,
  UpdateCollectionPayload,
} from "../../../interfaces/BusinessCollectionObject";

/** Shared wire shape — create and update take identical bodies (update is a
 *  full replace, not a patch), so both builders funnel through here to keep a
 *  future field addition from being forgotten on one side. */
function toWireBody(
  payload: CreateCollectionPayload
): Record<string, unknown> {
  return {
    collectionName: payload.collectionName.trim(),
    businessIds: payload.businessIds,
    bannerUrl: payload.bannerUrl,
  };
}

/** CreateCollectionPayload → POST /api/v1/business-collections wire body. */
export function buildCreateCollectionPayload(
  payload: CreateCollectionPayload
): Record<string, unknown> {
  return toWireBody(payload);
}

/** UpdateCollectionPayload → PUT /api/v1/business-collections/{id} wire body.
 *  Full replace, same three fields as create — `uid` is routed into the URL,
 *  never the body. */
export function buildUpdateCollectionPayload(
  payload: UpdateCollectionPayload
): Record<string, unknown> {
  return toWireBody(payload);
}

export default {
  buildCreateCollectionPayload,
  buildUpdateCollectionPayload,
};
